import { Dropdown, Menu, Row, Space, Spin } from 'antd'
import React, { useCallback, useMemo, useState } from 'react'
import { useHistory } from 'react-router-dom'
import { Balance, ChevronDown, ChevronUp } from '@yy/one-icon'
import { OneButton } from '@yy/one-ui'
import { REF_OBJECT } from '@/constant'
import { useDispatch, useSelector } from '@/store'
import { updateSetting } from '@/store/commonSlice'
import { getWalletInfo } from '@/store/userSlice'
import { translateCurrency } from '@/utils'
import styles from './index.module.less'

const Wallet: React.FC = () => {
  const history = useHistory()
  const dispatch = useDispatch()
  const [loading, setLoading] = useState(false)
  const [dropDownVisible, setDropDownVisible] = useState(false)

  const defaultWallet = useSelector((state) => state.user.walletList.find((wallet) => wallet.isDefault) || REF_OBJECT)
  const walletList = useSelector((state) => state.user.walletList)
  const hasMultiWallet = walletList.length > 1

  const handleOpen = () => {
    history.push('/wallet')
  }

  const defaultWalletChange = useCallback(
    async (v) => {
      setDropDownVisible(false)
      if (v.key === defaultWallet.currencyCode) {
        return
      }
      setLoading(true)
      try {
        // 更新默认币种钱包
        await dispatch(
          updateSetting([
            {
              settingCode: 'USER_DEFAULT_CURRENCY_CODE',
              dataValue: v.key,
            },
          ])
        )
        // 刷新余额
        await dispatch(getWalletInfo())
      } catch (error) {}
      setLoading(false)
    },
    [defaultWallet.currencyCode, dispatch]
  )

  const menu = useMemo(
    () =>
      hasMultiWallet ? (
        <Menu selectedKeys={[defaultWallet.currencyCode]} onClick={defaultWalletChange}>
          {walletList.map((item) => (
            <Menu.Item key={item.currencyCode}>
              <Space size={4}>
                <span>{item.currencyCode}</span>
                <span>{translateCurrency(item.totalBalance)}</span>
              </Space>
            </Menu.Item>
          ))}
        </Menu>
      ) : (
        <></>
      ),
    [defaultWallet.currencyCode, defaultWalletChange, hasMultiWallet, walletList]
  )

  return (
    <Dropdown overlay={menu} placement="bottom" onVisibleChange={setDropDownVisible} overlayClassName={styles.dropDown}>
      <div>
        <Spin spinning={loading} size="small">
          <Row style={{ marginRight: '10px' }} align="middle">
            <OneButton onClick={handleOpen} type="text">
              <Space className="color-grey-text-primary" size={6}>
                <Balance className={styles.icon} />
                <span>{defaultWallet.currencyCode}</span>
                <span>{translateCurrency(defaultWallet.totalBalance || 0)}</span>
                {hasMultiWallet ? dropDownVisible ? <ChevronUp className={styles.icon} /> : <ChevronDown className={styles.icon} /> : null}
              </Space>
            </OneButton>
          </Row>
        </Spin>
      </div>
    </Dropdown>
  )
}

Wallet.displayName = 'Wallet'
export default Wallet
